<template>
  <div class="freight-popup-main">
    <div v-if="data['milestonesData'].length > 0" class="milestones" :style="{ maxHeight: `${showMilestones ? '100' : '25' }px` }">
      <img class="close-milestone" src="https://dsmapi.logistics.systems/dsm6gicons/icons8-expand-arrow-24.png"
        :style="{ transform: `rotate(${showMilestones ? 180 : 0}deg)` }" @click="showMilestones ^= true">
      <div :style="{ opacity: showMilestones ? 1 : 0 }" class="milestones-data">
        <div v-for="(m, i) in data['milestonesData']" :key="i" class="milestones-item"
          :style="{ backgroundColor: `${m['BackColor']}` }">
          {{ m['ShowText'] }}
        </div>
      </div>
      <div :style="{ opacity: showMilestones ? 1 : 0 }" class="legend-data">
        <div v-for="(l, i) in Object.keys(data['legendData'])" :key="i" class="legend-item">
          <div class="legend-item-color" :style="{ backgroundColor: `${data['legendData'][l]}` }"></div>
          <div class="legend-item-name">{{ l }}</div>
        </div>
      </div>
      <div class="milestone-title" :style="{ opacity: showMilestones ? 0 : 1 }">Milestones</div>
    </div>

    <div class="popup-content">
      <div v-if="data['activeTab'] > 1" class="header-summary" :style="{ width: `${leftWidth}px`, minWidth: `${leftWidth}px` }">
        <div style="margin-bottom: 5px">Header Info</div>
        <Input :isDisabled="true" placeholder="Trans Mode" :inputValue="data['selectedTransMode'] ? data['selectedTransMode']['Description'] : ''"
          :title="data['selectedTransMode'] ? data['selectedTransMode']['Description'] : ''" :style="{ opacity: data['selectedTransMode'] ? '1' : '0.5' }" />

        <Input :isDisabled="true" placeholder="Cargo Type" :inputValue="data['selectedCargoType'] ? data['selectedCargoType']['Description'] : ''"
          :title="data['selectedCargoType'] ? data['selectedCargoType']['Description'] : ''" :style="{ opacity: data['selectedCargoType'] ? '1' : '0.5' }" />

        <Input :isDisabled="true" placeholder="Shipper" :inputValue="data['selectedShipper'] ? data['selectedShipper']['Shipper Name'] : ''"
          :title="data['selectedShipper'] ? data['selectedShipper']['Shipper Name'] : ''" :style="{ opacity: data['selectedShipper'] ? '1' : '0.5' }" />

        <Input :isDisabled="true" placeholder="Consignee" :inputValue="data['selectedConsignee'] ? data['selectedConsignee']['Consignee Name'] : ''"
          :title="data['selectedConsignee'] ? data['selectedConsignee']['Consignee Name'] : ''" :style="{ opacity: data['selectedConsignee'] ? '1' : '0.5' }" />

        <Input :isDisabled="true" placeholder="Notify Party" :inputValue="data['selectedNotifyParty'] ? data['selectedNotifyParty']['Notify Party Name'] : ''"
          :title="data['selectedNotifyParty'] ? data['selectedNotifyParty']['Notify Party Name'] : ''" :style="{ opacity: data['selectedNotifyParty'] ? '1' : '0.5' }" />
          
        <Input :isDisabled="true" placeholder="Cust Ref #" :inputValue="data['custRefNo'] ? data['custRefNo'] : ''"
          :title="data['custRefNo'] ? data['custRefNo'] : ''" :style="{ opacity: data['custRefNo'] ? '1' : '0.5' }" />

        <Input :isDisabled="true" :placeholder="data['bkgRefPlaceholder']" :inputValue="data['vbkgRefNo'] ? data['vbkgRefNo'] : ''"
          :title="data['vbkgRefNo'] ? data['vbkgRefNo'] : ''" :style="{ opacity: data['vbkgRefNo'] ? '1' : '0.5' }" />

        <Input :isDisabled="true" placeholder="Bill To" :inputValue="data['selectedBillTo'] ? data['selectedBillTo']['Customer Name'] : ''"
          :title="data['selectedBillTo'] ? data['selectedBillTo']['Customer Name'] : ''" :style="{ opacity: data['selectedBillTo'] ? '1' : '0.5' }" />

        <Input :isDisabled="true" placeholder="Job #" :inputValue="data['jobNo'] ? data['jobNo'] : ''"
          :title="data['jobNo'] ? data['jobNo'] : ''" :style="{ opacity: data['jobNo'] ? '1' : '0.5' }" />

        <Input :isDisabled="true" placeholder="Job Time" :inputValue="data['jobTime'] ? $dateTime.getDateTime(data['jobTime'], 'dd/MM/yyyy HH:mm') : ''"
          :title="data['jobTime'] ? $dateTime.getDateTime(data['jobTime'], 'dd/MM/yyyy HH:mm') : ''" :style="{ opacity: data['jobTime'] ? '1' : '0.5' }" />

        <Input :isDisabled="true" placeholder="Job State" :inputValue="data['jobStatus'] ? data['jobStatus'] : ''"
          :title="data['jobStatus'] ? data['jobStatus'] : ''" :style="{ opacity: data['jobStatus'] ? '1' : '0.5' }" />

        <div class="splitter" @mousedown="splitterMouseDown"></div>
      </div>

      <TabView :tabs="tabs" :activeTab.sync="data['activeTab']" :style="{ maxWidth: data['activeTab'] == 1 || data['activeTab'] == 0 ? '100%' : `calc(100% - ${leftWidth}px)` }"
        @tabChanged="tabChanged" />

      <div v-if="data['backLoad']" class="background-loading">
        <div class="loading-spinner"></div>
        <div>{{ data['backLoad'] }}</div>
      </div>
    </div>

    <Loader :isVisible="loading" :loadingText="loadText"/>
  </div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
import Dropdown from '@/components/Dropdown.vue';
import InputQuery from '@/components/InputQuery.vue';
import DateTimePicker from '@/components/DateTimePicker.vue';
import TabView from '@/components/TabView.vue';
import Loader from '@/components/Loader.vue';

var startPoint = null;
var startWidth = null;

export default {
  components: {
    Input, Dropdown, InputQuery, DateTimePicker, TabView, Loader
  },
  props: {
    data: { type: Object, default: function() { return {} } },
    tabs: { type: Array, default: function() { return [
      { title: 'Quick Entry', component: 'FreightQuickEntry', enabled: true, data: this.data },
      { title: 'Header Info', component: 'FreightHeaderInfo', enabled: true, data: this.data },
      { title: 'General Info', component: 'FreightGeneralDetails', enabled: true, data: this.data.generalDetails },
      { title: 'Shipping Info', component: 'FreightShippingInfo', enabled: true, data: this.data.shippingInfo },
      { title: 'Cargo Info', component: 'FreightCargoInfo', enabled: true, data: this.data.cargoInfo },
      { title: 'Documents', component: 'FreightDocuments', enabled: true, data: this.data.documents },
      { title: 'Delivery Note', component: 'FreightDeliveryNote', enabled: false },
      { title: 'ROT', component: 'FreightROT', enabled: false },
      { title: 'TAS & KPI', component: 'FreightTASandKPI', enabled: false, data: this.data.TASKPI },
      { title: 'SMK', component: 'FreightSMK', enabled: false },
    ] } },

    leftWidth: { type: Number, default: 115 },

    loading: { type: Boolean, default: false },
    loadText: { type: String, default: 'Loading' },

    viewMode: { type: Boolean, default: false },

    showMilestones: { type: Boolean, default: true },
  },
  methods: {
    transModeSelected: function(e) {
      var shippingInfoTab = this.tabs[2].data;
      switch (e['Trans Mode']) {
        case 'G':
        case 'S':
          shippingInfoTab.transNoPlaceholder = 'Ship Call #';
          shippingInfoTab.transIDPlaceholder = 'Vessel ID';
          shippingInfoTab.transAgentPlaceholder = 'Shipping Agent';
          shippingInfoTab.transLinePlaceholder = 'Shipping Line';
          break;
        case 'A':
          shippingInfoTab.transNoPlaceholder = 'Flight ID';
          shippingInfoTab.transIDPlaceholder = 'Flight Code';
          shippingInfoTab.transAgentPlaceholder = 'AirLine Agent';
          shippingInfoTab.transLinePlaceholder = 'AirLine Code';
          break;
        case 'L':
          shippingInfoTab.transNoPlaceholder = 'Fleet ID';
          shippingInfoTab.transIDPlaceholder = 'Vehicle Code';
          shippingInfoTab.transAgentPlaceholder = 'Fleet Agent';
          shippingInfoTab.transLinePlaceholder = 'Fleet Line Code';
          break;
        case 'R':
          shippingInfoTab.transNoPlaceholder = 'Train ID';
          shippingInfoTab.transIDPlaceholder = 'Train Code';
          shippingInfoTab.transAgentPlaceholder = 'Railway Agent';
          shippingInfoTab.transLinePlaceholder = 'Railway Code';
          break;
      }
    },
    billToSelected: function(item) {
      // console.log(item);
    },
    splitterMouseDown: function(e) {
      startPoint = e.clientX;
      if (!startWidth) {
        startWidth = this.leftWidth;
      }
    },
    tabChanged: function(e) {
      this.$bus.$emit('tabChanged');
    }
  },
  mounted() {
    window.addEventListener('mousemove', (e) => {
      if (startPoint) {
        var change = e.clientX - startPoint;
        var width = startWidth + change;

        if (width >= 115 && width <= 300) {
          this.leftWidth = startWidth + change;
        }
      }
    });

    window.addEventListener('mouseup', () => {
      startPoint = null;
      startWidth = null;
    });

    this.$bus.$on('openMilestones', () => {
      this.showMilestones = true;
    });

    this.$bus.$on('ShippingInfoDownloaded', () => {
      this.tabs[0]['enabled'] = true;
    });

    this.$bus.$on('changeMode', (e) => {
      if (e == 'E' || e == 'N') {
        this.tabs[6]['enabled'] = false;
        this.tabs[7]['enabled'] = false;
        this.tabs[8]['enabled'] = false;
        this.tabs[9]['enabled'] = false;
      } else {
        this.tabs[6]['enabled'] = true;
        this.tabs[7]['enabled'] = true;
        this.tabs[8]['enabled'] = true;
        this.tabs[9]['enabled'] = true;
      }
    });
  },
  destroyed() {
    this.$bus.$off('changeMode');
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.freight-popup-main {
  position: relative;
  height: 100%;
  
  > .milestones {
    width: 100%;
    border: 1px solid rgba(0,0,0,0.5);
    margin-bottom: 5px;
    padding: 5px;
    position: relative;
    transition: $transition-time;

    > .milestone-title {
      position: absolute;
      top: 2.5px;
    }

    > .close-milestone {
      position: absolute;
      bottom: 0;
      right: 0;
      cursor: pointer;
      transition: $transition-time;
      z-index: 10;
    }

    > .milestones-data, > .legend-data {
      display: flex;
      overflow: auto;
      transition: $transition-time;
    }

    > .milestones-data {
      > .milestones-item {
        white-space: nowrap;
        margin-right: 3px;
        padding: 3px 5px;
        border: 1px solid rgba(0,0,0,0.2);
      }
    }

    > .legend-data {
      > .legend-item {
        display: flex;
        align-items: center;
        margin-right: 5px;

        > .legend-item-color {
          min-height: 10px;
          min-width: 10px;
          margin-right: 3px;
          border: 1px solid rgba(0,0,0,0.2);
        }
      }
    }
  }

  > .popup-content {
    display: flex;

    > .header-summary {
      height: 100%;
      margin-right: 5px;
      text-align: center;
      position: relative;

      > .splitter {
        width: 5px;
        // background-color: rgba(0,0,0,0.5);
        height: 100%;
        position: absolute;
        top: 0;
        left: 100%;
        cursor: col-resize;
        z-index: 100;
      }
    }

    > .background-loading {
      position: absolute;
      bottom: 0;
      display: flex;
      align-items: center;

      > .loading-spinner {
        margin-right: 5px;
        height: 15px;
        width: 15px;
        border-width: 2px 2px 2px 2px;
        border-style: solid;
        border-color: transparent rgba(0,0,0,0.5) rgba(0,0,0,0.5) rgba(0,0,0,0.5);
        border-radius: 100%;
        animation: rotate 1s linear infinite;
      }
    }
  }
}

@keyframes rotate {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>